/**
 * 通用兜底编辑器：未知 targeting_type 用双 textarea（targeting_id / ext_info），
 * ext_info 以 { 或 [ 开头时做 JSON 校验提示（后端 legal_date/special_condition 强校验）。
 */
import type { EditorProps } from "./types";

export function GenericConfigEditor({ item, onChange }: EditorProps) {
  const ext = item.ext_info ?? "";
  const extTrim = ext.trim();
  let jsonError = "";
  if (extTrim.startsWith("{") || extTrim.startsWith("[")) {
    try {
      JSON.parse(ext);
    } catch (e) {
      jsonError = `JSON 无效：${(e as Error).message}`;
    }
  }

  return (
    <div className="space-y-2">
      <div>
        <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-text-strong">
          targeting_id
        </div>
        <textarea
          className="leo-input font-mono"
          rows={3}
          value={item.targeting_id}
          onChange={(e) =>
            onChange({ targeting_id: e.target.value, ext_info: ext })
          }
        />
      </div>
      <div>
        <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-text-strong">
          ext_info
        </div>
        <textarea
          className="leo-input font-mono"
          rows={4}
          value={ext}
          onChange={(e) =>
            onChange({ targeting_id: item.targeting_id, ext_info: e.target.value })
          }
        />
        {jsonError ? (
          <div className="mt-1 text-[11px] text-red-400">{jsonError}</div>
        ) : null}
      </div>
    </div>
  );
}
